var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "appeal",
      style: _vm.currentIndex != 0 && !_vm.$isFlag ? "background:#fff" : ""
    },
    [
      _c("header-item", {
        attrs: {
          "title-array": _vm.titleArray,
          "is-show": true,
          "title-mb": _vm.titleArray[0],
          "type-next": "click"
        },
        on: { navBarClick: _vm.navBarClick }
      }),
      _vm.currentIndex == 0
        ? _c("div", { staticClass: "formClass" }, [
            _c("div", { staticClass: "auth" }, [
              _c(
                "div",
                { staticClass: "name", on: { click: _vm.accountClick } },
                [
                  _c("img", {
                    attrs: {
                      src: require("assets/images/accountCenter/24.png"),
                      alt: ""
                    }
                  }),
                  _vm._m(0)
                ]
              ),
              _c("div", { staticClass: "name", on: { click: _vm.gameClick } }, [
                _c("img", {
                  attrs: {
                    src: require("assets/images/accountCenter/26.png"),
                    alt: ""
                  }
                }),
                _vm._m(1)
              ])
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("p", [_vm._v("自助保护性冻结")]),
      _c("p", [_vm._v("如果账号被盗/被骗可以自助冻结账号保障财产安全")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("p", [_vm._v("解除保护性冻结")]),
      _c("p", [_vm._v("账号通过申诉确保安全之后可以自助解除保护性冻结")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }